import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { LoadingController } from '@ionic/angular';
import * as CryptoJS from 'crypto-js';
import { FileSaver } from '@ionic-native/file';
import { Observable, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';


let apiUrl1 = 'https://dev-coboticsai-touchstone.appspot.com'
let apiUrl2 = 'https://goodluck-1091614272118.us-south1.run.app'

// let apiUrl2 = 'https://goodluck-1097757656517.europe-west1.run.app'
//  let apiUrl1='https://smart-logistics-release-2.uk.r.appspot.com';
//  let apiUrl1='http://localhost:8080';

@Injectable({
  providedIn: 'root'
})
export class WebapiService { 
  shipperdata:any=[];
  useroles=[];
 
  baseurl='http://127.0.0.1:8080/'
  selectedSearchfilter: any = {

    "pricemodel": "ATA",
    "partner": "Partner_1",
    "Service_Level": "STD",
    "origin": "HKG",
    "destination": "LAX",
    "userData":"ATA",
    "type":'P'
  }
  expirflag=false;
  forcastlist:any
  seletedlane:any;

  userdata={
    iid:"",
    semail:'',
    uconfig:'',
    Role:'',
    otherDetails1:''
  }

  cvalues={
    high_op_spend:5000,
    minimim_priority:0.97,
    min_total_assesorial:25,
    mom_delta:0.25

  }


  marketoutlooktitle:any
  totalcount = 0
  ccount = 0
  icount = 0
  corrlist = []
  marketoutlooklist=[]
  corr_list = []

  im_list = []
  loading: any;
  dashboard_count:any; 

  readFile(filePath: string): Observable<string> {
    return this.http.get(filePath, { responseType: 'text' });
  }

  categoryuri =[
    {
        "uri": "dmoz",
        "label": "dmoz",
        "parentUri": ""
    },
    {
        "uri": "news",
        "label": "news",
        "parentUri": ""
    },
    {
        "uri": "dmoz/Arts",
        "label": "dmoz/Arts",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Business",
        "label": "dmoz/Business",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Computers",
        "label": "dmoz/Computers",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Games",
        "label": "dmoz/Games",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Health",
        "label": "dmoz/Health",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Home",
        "label": "dmoz/Home",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Recreation",
        "label": "dmoz/Recreation",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Science",
        "label": "dmoz/Science",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Shopping",
        "label": "dmoz/Shopping",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Society",
        "label": "dmoz/Society",
        "parentUri": "dmoz"
    },
    {
        "uri": "dmoz/Sports",
        "label": "dmoz/Sports",
        "parentUri": "dmoz"
    },
    {
        "uri": "news/Arts_and_Entertainment",
        "label": "news/Arts and Entertainment",
        "parentUri": "news"
    },
    {
        "uri": "news/Business",
        "label": "news/Business",
        "parentUri": "news"
    },
    {
        "uri": "news/Environment",
        "label": "news/Environment",
        "parentUri": "news"
    },
    {
        "uri": "news/Health",
        "label": "news/Health",
        "parentUri": "news"
    },
    {
        "uri": "news/Politics",
        "label": "news/Politics",
        "parentUri": "news"
    },
    {
        "uri": "news/Science",
        "label": "news/Science",
        "parentUri": "news"
    },
    {
        "uri": "news/Sports",
        "label": "news/Sports",
        "parentUri": "news"
    }
]

  constructor(public router:Router,public http: HttpClient, public loadingController: LoadingController) {
    //console.log('Hello DatacontrollerProvider Provider');
  }
  key = CryptoJS.enc.Utf8.parse('VC1TVJHtzW8p3BQtkwe7qEMHNZpta4N7');

  
  encrypt(msgString) {
    // msgString is expected to be Utf8 encoded
    var iv :any= CryptoJS.lib.WordArray.random(16);
    var encrypted = CryptoJS.AES.encrypt(msgString, this.key, {
        iv: iv
    });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
}

decrypt(ciphertextStr) {
    var ciphertext= CryptoJS.enc.Base64.parse(ciphertextStr);
    // split IV and ciphertext
    var iv = ciphertext.clone();
    iv.sigBytes = 16;
    iv.clamp();
    ciphertext.words.splice(0, 4); // delete 4 words = 16 bytes
    ciphertext.sigBytes -= 16;
   
    // decryption
    //@ts-ignore
    var decrypted = CryptoJS.AES.decrypt({ciphertext:ciphertext}, this.key, {
        iv: iv
    }); 
    
    return decrypted.toString(CryptoJS.enc.Utf8);
}
  
  logout()
  {
    this.userdata.iid=="";

    localStorage.clear();
    this.router.navigateByUrl('/signup');
  }
 
 

  // Method to call protected API
  postData(credentials: any, type: string, signal?: AbortSignal): Promise<any> {
  return new Promise((resolve, reject) => {

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });

    const options: any = {
      headers,
      withCredentials: true
    };

    // 👉 Add signal only if caller passed it
    if (signal) {
      options.signal = signal;
    }

    this.http.post<any>(
      `${apiUrl1}/${type}`, 
      credentials,
      options
    ).subscribe(
      res => resolve(res),
      err => {
        console.error('Login failed:', err.status);

        if ((err.status === 401 || err.status === 422) && this.expirflag === false) {
          this.expirflag = true;
          alert("Your session has expired or the token is invalid. Please log in again.");
          this.logout();
        }

        reject(err);
      }
    );
  });
}

postData_cancel(credentials: any, type: string): { 
  promise: Promise<any>, 
  cancel: () => void 
} {
  
  let subscription: Subscription;

  const promise = new Promise((resolve, reject) => {

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });

    subscription = this.http.post<any>(
      `${apiUrl1}/${type}`,
      credentials,
      { headers, withCredentials: true }
    ).subscribe(
      res => resolve(res),
      err => {
        console.error('API failed:', err.status);

        if ((err.status === 401 || err.status === 422) && this.expirflag === false) {
          this.expirflag = true;
          alert("Your session has expired or the token is invalid. Please log in again.");
          this.logout();
        }

        reject(err);
      }
    );
  });

  // Return both
  return {
    promise,
    cancel: () => subscription?.unsubscribe()
  };
}

  postDatacloud(credentials, type): Promise<any> {
    return new Promise((resolve, reject) =>{

      const headers = new HttpHeaders({
      'Content-Type': 'application/json'   // Add the Bearer token to the Authorization header
    });

     this.http.post<any>(
      `${apiUrl2}`, 
      credentials,
      { headers}  // Send cookies with the request
    ).subscribe(res => {
      resolve(res);

    }, (err) => {

      console.error('Login failed:', err.status);
      if (err.status === 401||err.status===422) {
        if(this.expirflag==false)
         {
            this.expirflag=true;
            alert("Your session has expired or the token is invalid. Please log in again.");
             this.logout();
         }
        
        
      }
      reject(err);
    });
  });

  
  }

  

  //final for file uplaod with token
  postData1(credentials, type) {

    const token = localStorage.getItem('token'); 
    var header = new HttpHeaders({
      'Authorization': 'Bearer '+token  // Add the Bearer token to the Authorization header
    });
    // header.append('Accept', 'application/json');
    // if (token) {
    //   header.append('Authorization', `Bearer ${token}`);
    // }
    // console.log(header)
    return new Promise((resolve, reject) => {
     // //console.log(apiUrl1);
      ////console.log(credentials);
      this.http.post(apiUrl1 + "/" + type, credentials,{headers:header})
        .subscribe(res => {
          resolve(res);

        }, (err) => {
          if (err.status === 401||err.status===422) {
            if(this.expirflag==false)
              {
                 this.expirflag=true;
                 alert("Your session has expired or the token is invalid. Please log in again.");
                  this.logout();
              }
          }
          reject(err);

        });
    });

  }
  

  postDataWithProgress(formData: FormData, endpoint: string): Observable<HttpEvent<any>> {

    const req = new HttpRequest('POST', `${apiUrl1}/${endpoint}`, formData, {
       reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(req);
  }


  translate(text){
    return new Promise((resolve, reject) => {
    this.http.get("https://translation.googleapis.com/language/translate/v2?key=AIzaSyDoe6vJ3aMktPt4QCryE-xznr35YZmqkqs&q="+text+"&target=en")
    .subscribe(res => {
      resolve(res);

    }, (err) => {

      reject(err);
    });
  });

  }
  

  downloadCsv(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }


  saveTextAsFile (data, filename){

      if(!data) {
          console.error('Console.save: No data')
          return;
      }

      if(!filename) filename = 'console.json'

      var blob = new Blob([data], {type: 'text/xlsx'}),
          e    = document.createEvent('MouseEvents'),
          a    = document.createElement('a')
// FOR IE:

if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
}
else{
    var e = document.createEvent('MouseEvents'),
        a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/xlsx', a.download, a.href].join(':');
    e.initEvent('click', true, false)
    a.dispatchEvent(e);
}
    }






    download(type)
    {
      return new Promise((resolve, reject) => {
   
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });

      this.http.post(apiUrl1 + '/download/' + type, {}, {
        headers,
        responseType: 'blob'  // <-- important for file download
        }).subscribe((blob) => {
            console.log('Download success!');

            const fileName = type; // type includes extension
            const downloadLink = document.createElement('a');
            const url = window.URL.createObjectURL(blob);

            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();

            window.URL.revokeObjectURL(url); // cleanup

            resolve({'result': 1});
        }, (err) => {
            if (err.status === 401 || err.status === 422) {
                if (!this.expirflag) {
                    this.expirflag = true;
                    alert("Your session has expired or the token is invalid. Please log in again.");
                    this.logout();
                }
            }
            reject(err);
        });
      
      });
    }

    download_data(type,data)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_demand_sensing_data',data,{headers,responseType: 'text'}).subscribe((val) => {

                console.log(val);

      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = type
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    download_allo(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_allo/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }

    download_ratebook(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_ratebookm/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
download_service(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_servicetype/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    download_warehouse(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_warehouse/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    download_warehouse_new(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_warehouse_new/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    download_warehouse_weekly(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download_warehouse_weekly/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = filename
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    download_F(type,filename)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
      this.http.post(apiUrl1 +'/download/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
      console.log(val)
        var fileName = filename+".csv"
       this.saveTextAsFile(val, fileName);
        //console.log('success!');
        resolve({'result':1});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
    
    // used
    getfile_content(type)
    {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');  // Retrieve the token from localStorage
        const headers = new HttpHeaders({
        'Authorization': 'Bearer '+token        
      });
   
      this.http.post(apiUrl1 +'/download/'+type,{},{headers,responseType: 'text'}).subscribe((val) => {
      //var blob = new Blob([val], {type: "text/plain;charset=utf-8"}); 
        var fileName = type+".csv"
      
        resolve({'result':val});

      }, (err) => {
        if (err.status === 401||err.status===422) {
          if(this.expirflag==false)
            {
               this.expirflag=true;
               alert("Your session has expired or the token is invalid. Please log in again.");
                this.logout();
            }
        }
      });
        });
    }
   
    
  
  async presentLoadingWithOptions(e) {
    const loading = await this.loadingController.create({
      spinner: null,
      duration: 10000,
      message: 'Please wait...',
      translucent: true,
      cssClass: 'custom-class custom-loading'
    });
    return await loading.present();
  }

  async presentLoading(e) {

    this.loading = await this.loadingController.create({
      message: 'Please wait...',
      duration: 2200

    });

    return await this.loading.present();


    //console.log('Loading dismissed!');
  }

  async LoaderonDidDismiss(e) {

    // const { role, data } = await  this.loading.dismiss();IndexIgnore .htaccess */.??* *~ *# */HEADER* */README* */_vti*

  }
// Http Options
httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })


}


chunkSize = 20 * 1024 * 1024; // 20MB

  async uploadFile(file: File, sessionId: string,type:string,uby:string): Promise<void> {
    const totalChunks = Math.ceil(file.size / this.chunkSize);
 const token = localStorage.getItem('token'); 
    var header = new HttpHeaders({
      'Authorization': 'Bearer '+token  // Add the Bearer token to the Authorization header
    });
    for (let index = 0; index < totalChunks; index++) {
      const start = index * this.chunkSize;
      const end = Math.min(start + this.chunkSize, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunk_index', index.toString());
      formData.append('session_id', sessionId);

      await this.http.post(apiUrl1+'/upload_chunk', formData,{headers:header}).toPromise();
    }

    // Finalize the upload
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    // const body = new URLSearchParams({ session_id: sessionId });
 const formData = new FormData();
      
      formData.append('session_id', sessionId);
      formData.append('_type', type);
      formData.append('uby', uby);

      
    await this.http.post(apiUrl1+'/upload_chunk/complete',formData, {headers:header}).toPromise();
    console.log("Upload completed.");
  }

  
  postDatareport(credentials, type) {


    var api="https://www.touchstone-ai.com/mail/mailreport.php"
    var header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('Accept', 'application/json');
    return new Promise((resolve, reject) => {
      //console.log(apiUrl1);
      //console.log(credentials);
      this.http.post(api + "?action=" + type, credentials, this.httpOptions)
        .subscribe(res => {
          resolve(res);

        }, (err) => {
    
          reject(err);
        });
    });


    
  }
  postDatareportp(credentials, type) {


    var api="https://www.touchstone-ai.com/mail/mailreport_partner.php"
    var header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('Accept', 'application/json');
    return new Promise((resolve, reject) => {
      //console.log(apiUrl1);
      //console.log(credentials);
      this.http.post(api + "?action=" + type, credentials, this.httpOptions)
        .subscribe(res => {
          resolve(res);

        }, (err) => {
    
          reject(err);
        });
    });


    
  }

  addaccesslog(module){
    // iUserid =_json['iUserid']
    // sUseremail =_json['sUseremail']
    // dtStarttime =_json['dtStarttime']
    // dtEndtime =_json['dtEndtime']
    // iModule =_json['iModule']
    var userid =localStorage.getItem('user');
    var email =localStorage.getItem('email');
    var filter ={'iUserid':userid,'sUseremail':email,'iModule':module}
    // else
    //   filter ={'startdate':this.endofweek.add(1,'days').format('MM/DD/YYYY'),nweek:4,weeklist:[]}

      
    this.postData(filter, 'accesslog').then((result) => {

      //console.log('access',result);




    });
  }

  groupAndAverage(data, keysToGroupBy, keysToAvg) {
  const groupMap = new Map();

  data.forEach(item => {
    // Create a unique group key
    const groupKey = keysToGroupBy.map(key => item[key]).join('|');
    
    if (!groupMap.has(groupKey)) {
        const groupValues = {};
        keysToGroupBy.forEach(key => {
          groupValues[key] = item[key];
        });

        groupMap.set(groupKey, {
          items: [],
          groupValues
        });
    }

    groupMap.get(groupKey).items.push(item);
  });

  const result = [];

  for (const [_, group] of groupMap) {
    const averages = {};

    keysToAvg.forEach(key => {
      let sum = 0;
      let count = 0;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined && value !== 0) {
          sum += value;
          count += 1;
        }
      });

      averages[key] = count > 0 ? sum / count : null;
    });

    result.push({
      ...group.groupValues,
      ...averages
    });
  }

  return result;
}

groupAverageAndSum(data, keysToGroupBy, keysToAvg, keysToSum) {
  const groupMap = new Map();

  // Group data by keys
  data.forEach(item => {
    const groupKey = keysToGroupBy.map(key => item[key]).join('|');

    if (!groupMap.has(groupKey)) {
      const groupValues = {};
      keysToGroupBy.forEach(key => {
        groupValues[key] = item[key];
      });

      groupMap.set(groupKey, {
        items: [],
        groupValues
      });
    }

    groupMap.get(groupKey).items.push(item);
  });

  const result = [];

  for (const [, group] of groupMap) {
    const averages = {};
    const sums = {};

    // Compute averages (excluding null, undefined, or 0)
    keysToAvg.forEach(key => {
      let sum = 0;
      let count = 0;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined && value !== 0) {
          sum += value;
          count += 1;
        }
      });

      averages[key] = count > 0 ? sum / count : null;
    });

    // Compute sums (excluding only null and undefined)
    keysToSum.forEach(key => {
      let total = 0;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined) {
          total += value;
        }
      });

      sums[key] = total;
    });

    result.push({
      ...group.groupValues,
      ...averages,
      ...sums
    });
  }

  return result;
}

groupAverageSumMax(data, keysToGroupBy, keysToAvg, keysToSum, keysToMax) {
  const groupMap = new Map();

  // Group data by keys
  data.forEach(item => {
    const groupKey = keysToGroupBy.map(key => item[key]).join('|');

    if (!groupMap.has(groupKey)) {
      const groupValues = {};
      keysToGroupBy.forEach(key => {
        groupValues[key] = item[key];
      });

      groupMap.set(groupKey, {
        items: [],
        groupValues
      });
    }

    groupMap.get(groupKey).items.push(item);
  });

  const result = [];

  for (const [, group] of groupMap) {
    const averages = {};
    const sums = {};
    const maxs = {};

    // Compute averages (excluding null, undefined, or 0)
    keysToAvg.forEach(key => {
      let sum = 0;
      let count = 0;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined && value !== 0) {
          sum += value;
          count += 1;
        }
      });

      averages[key] = count > 0 ? sum / count : null;
    });

    // Compute sums (excluding only null and undefined)
    keysToSum.forEach(key => {
      let total = 0;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined) {
          total += value;
        }
      });

      sums[key] = total;
    });

    // Compute max values (excluding null and undefined)
    keysToMax.forEach(key => {
      let maxValue = null;

      group.items.forEach(item => {
        const value = item[key];
        if (value !== null && value !== undefined) {
          if (maxValue === null || value > maxValue) {
            maxValue = value;
          }
        }
      });

      maxs[key] = maxValue;
    });

    result.push({
      ...group.groupValues,
      ...averages,
      ...sums,
      ...maxs
    });
  }

  return result;
}

//filter list

filterListByConfig(list, filterConfig) {
  return list.filter(item => {
    return Object.entries(filterConfig).every(([key, value]) => {
      // If value is blank/empty/null/undefined, ignore that filter
      if (value === '' || value == null) return true;

      // Match exact value
      return item[key] === value;
    });
  });
}

 getDistinctByKeys(data, keys) {
  const seen = new Set();
  const result = [];

  data.forEach(item => {
    const compositeKey = keys.map(key => item[key]).join('|');

    if (!seen.has(compositeKey)) {
      seen.add(compositeKey);

      // Only include the passed keys in the result
      const filteredItem = {};
      keys.forEach(key => {
        filteredItem[key] = item[key];
      });

      result.push(filteredItem);
    }
  });

  return result;
}

getGlobalMinMax(
  chartList: any[],
  valueColumns?: (number | string)[]
): { min: number; maxx: number } {
  let globalMin = Number.POSITIVE_INFINITY;
  let globalMax = Number.NEGATIVE_INFINITY;
  let found = false;

  chartList.forEach(chart => {
    const data = chart.dataTable || [];
    if (!data.length || data.length < 2) return;

    const headers = data[0];
    const rows = data.slice(1);

    let numericIndexes: number[];

    if (!valueColumns) {
      // Scan all rows to detect numeric columns
      const firstNumericRow = rows.find(r =>
        r.some(val => typeof val === 'number' && !isNaN(val))
      );
      if (firstNumericRow) {
        numericIndexes = firstNumericRow
          .map((val: any, idx: number) =>
            typeof val === 'number' && !isNaN(val) ? idx : -1
          )
          .filter(idx => idx !== -1);
      } else {
        numericIndexes = [];
      }
    } else {
      if (typeof valueColumns[0] === 'string') {
        numericIndexes = (valueColumns as string[]).map(name =>
          headers.indexOf(name)
        );
      } else {
        numericIndexes = valueColumns as number[];
      }
    }

    rows.forEach(row => {
      numericIndexes.forEach(idx => {
        const val = row[idx];
        if (typeof val === 'number' && !isNaN(val)) {
          found = true;
          if (val < globalMin) globalMin = val;
          if (val > globalMax) globalMax = val;
        }
      });
    });
  });

  if (!found) {
    return { min: 0, maxx: 0 }; // No valid numeric data
  }

  return { min: globalMin, maxx: globalMax };
}
}
